import React from 'react';

const Testimonials2 = () => {
  // Static data for the testimonials, following the same pattern.
  const testimonials = [
    {
      text: "The Maldives package was absolutely incredible. The resort was even better than pictured, and the staff went above and beyond to make our stay memorable. Will definitely book with TravelEase again!",
      author: "Sarah Johnson",
      role: "Maldives Traveler",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=500&q=80",
      rating: 5
    },
    {
      text: "Our family trip to Bali was perfectly organized. The activities were engaging for both kids and adults, and the guides were knowledgeable and friendly. Thanks for the wonderful memories!",
      author: "Michael Chen",
      role: "Family Traveler",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=500&q=80",
      rating: 5
    },
    {
      text: "The pilgrimage tour to Varanasi was a spiritually enriching experience. The accommodations were comfortable, and the itinerary perfectly balanced sightseeing with spiritual activities. Highly recommended!",
      author: "Priya Sharma",
      role: "Pilgrimage Traveler",
      image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=500&q=80",
      rating: 4
    }
  ];

  // Helper to render the star icons, adjusted for the dark theme.
  const renderStars = (rating) => {
    let stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(
        <span key={i} className={i < rating ? 'text-primary' : 'text-white-50'}>★</span>
      );
    }
    return stars;
  };

  return (
    // NEW DESIGN: A dark-themed section
    <section className="testimonials-section-3 py-5 bg-dark text-light">
      <div className="container">
        {/* Section Header with text appropriate for a dark background */}
        <div className="text-center mb-5">
          <h2 className="display-5 fw-bold">Trusted by Travelers Worldwide</h2>
          <p className="lead text-white-50">Discover the experiences that define our service</p>
        </div>
        
        {/* Testimonials Grid using the same mapping pattern */}
        <div className="row g-4">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="col-lg-4 d-flex align-items-stretch">
              {/* NEW DESIGN: A card with a left accent border */}
              <div className="testimonial-card-3 w-100 p-4 rounded d-flex flex-column border-start border-primary border-4" style={{backgroundColor: 'rgba(255, 255, 255, 0.05)'}}>
                <p className="testimonial-text mb-4 fs-5 flex-grow-1">
                  “{testimonial.text}”
                </p>
                <div className="d-flex align-items-center mt-auto">
                  <img 
                    src={testimonial.image} 
                    className="testimonial-image-3 rounded-circle me-3" 
                    alt={testimonial.author} 
                  />
                  <div>
                    <h5 className="author-name fw-bold mb-0">{testimonial.author}</h5>
                    <div className="rating-stars">
                      {renderStars(testimonial.rating)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials2;

/* 
  Optional CSS for this component.
  You can add this to your main CSS file.

  .testimonial-image-3 {
    width: 48px;
    height: 48px;
    object-fit: cover;
  }
*/